// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*DESKTOP & TABLET*/
@media screen and (min-width:767px) {
    .popper_ul__Y3On6 {
        list-style-type: none;
        margin: 0;
        padding: 0;
        overflow: hidden;
    }

    .popper_states__e8ONI {
        display: grid;
        grid-template-columns: 20% 80%;
    }

    .popper_paper__bYYUy {
        margin-top: 100px;
        height: 40%;
        display: flex;
        flex-direction: column;
    }


    .popper_legenda__Vx9Ha {
        padding-right: 15px;
    }

    .popper_button__c4WdC {
        text-transform: capitalize !important;
        margin-top: 10px !important;
    }
}

.popper_antpopover__yglvA {
    z-index: 30000 !important;
}

/*MOBILE*/
@media screen and (max-width:767px) {
    .popper_ul__Y3On6 {
        font-size: 12px;
        list-style-type: none;
        margin: 0;
        padding: 0;
    }

    .popper_ul__Y3On6 li {
        float: left;
    }

    .popper_paper__bYYUy {
        margin-top: 80px;
        padding: 5% 1%;
        height: 130px;
        margin-left: 0%;
    }

    .popper_states__e8ONI {
        display: grid;
        grid-template-columns: 20% 80%;
    }

    .popper_ul__Y3On6 li {
        float: left;
    }

    .popper_button__c4WdC {
        text-transform: capitalize !important;
        margin-top: 30% !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/popper/popper.module.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI;QACI,qBAAqB;QACrB,SAAS;QACT,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,8BAA8B;IAClC;;IAEA;QACI,iBAAiB;QACjB,WAAW;QACX,aAAa;QACb,sBAAsB;IAC1B;;;IAGA;QACI,mBAAmB;IACvB;;IAEA;QACI,qCAAqC;QACrC,2BAA2B;IAC/B;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,SAAS;AACT;IACI;QACI,eAAe;QACf,qBAAqB;QACrB,SAAS;QACT,UAAU;IACd;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,cAAc;QACd,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,8BAA8B;IAClC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,qCAAqC;QACrC,0BAA0B;IAC9B;AACJ","sourcesContent":["/*DESKTOP & TABLET*/\n@media screen and (min-width:767px) {\n    .ul {\n        list-style-type: none;\n        margin: 0;\n        padding: 0;\n        overflow: hidden;\n    }\n\n    .states {\n        display: grid;\n        grid-template-columns: 20% 80%;\n    }\n\n    .paper {\n        margin-top: 100px;\n        height: 40%;\n        display: flex;\n        flex-direction: column;\n    }\n\n\n    .legenda {\n        padding-right: 15px;\n    }\n\n    .button {\n        text-transform: capitalize !important;\n        margin-top: 10px !important;\n    }\n}\n\n.antpopover {\n    z-index: 30000 !important;\n}\n\n/*MOBILE*/\n@media screen and (max-width:767px) {\n    .ul {\n        font-size: 12px;\n        list-style-type: none;\n        margin: 0;\n        padding: 0;\n    }\n\n    .ul li {\n        float: left;\n    }\n\n    .paper {\n        margin-top: 80px;\n        padding: 5% 1%;\n        height: 130px;\n        margin-left: 0%;\n    }\n\n    .states {\n        display: grid;\n        grid-template-columns: 20% 80%;\n    }\n\n    .ul li {\n        float: left;\n    }\n\n    .button {\n        text-transform: capitalize !important;\n        margin-top: 30% !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ul": `popper_ul__Y3On6`,
	"states": `popper_states__e8ONI`,
	"paper": `popper_paper__bYYUy`,
	"legenda": `popper_legenda__Vx9Ha`,
	"button": `popper_button__c4WdC`,
	"antpopover": `popper_antpopover__yglvA`
};
export default ___CSS_LOADER_EXPORT___;
